module.exports = __webpack_public_path__ + "img/img-none2.619b875c.png";